module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _commandSentence = __webpack_require__(1);
	
	Object.defineProperty(exports, 'CommandSentence', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_commandSentence).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommandSentence = function (_Component) {
		_inherits(CommandSentence, _Component);
	
		function CommandSentence() {
			_classCallCheck(this, CommandSentence);
	
			return _possibleConstructorReturn(this, (CommandSentence.__proto__ || Object.getPrototypeOf(CommandSentence)).apply(this, arguments));
		}
	
		_createClass(CommandSentence, [{
			key: 'UNSAFE_componentWillUpdate',
	
	
			// eslint-disable-next-line camelcase
			value: function UNSAFE_componentWillUpdate(nextProps) {
				if (this.props.template !== nextProps.template) {
					this.templateSegments = null;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (!this.templateSegments) {
					this.templateSegments = convertTemplate(this.props.template);
				}
	
				var namedChildren = {};
				_react2.default.Children.forEach(this.props.children || [], function (child) {
					if (child.type === Field && child.props && child.props.name) {
						namedChildren[child.props.name] = child.props.children;
					}
				});
	
				return _react2.default.createElement(this.props.Container || 'div', { className: this.props.className }, this.templateSegments.map(function (x) {
					return x.text || namedChildren[x.field];
				}));
			}
		}]);
	
		return CommandSentence;
	}(_react.Component);
	
	CommandSentence.propTypes = {
		template: _propTypes2.default.string,
		children: _propTypes2.default.node,
		Container: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
		className: _propTypes2.default.string
	};
	CommandSentence.Field = Field;
	exports.default = CommandSentence;
	
	
	function Field(_ref) {
		var children = _ref.children;
	
		return _react2.default.createElement(
			'span',
			null,
			children
		);
	}
	
	Field.propTypes = {
		children: _propTypes2.default.node
	};
	
	var formatRegex = /%([A-Z_]+)%/g;
	
	function convertTemplate(template) {
		if (!template) {
			return [];
		}
	
		var result = [];
	
		var lastIndex = 0;
		for (var match = formatRegex.exec(template); match !== null; match = formatRegex.exec(template)) {
			if (lastIndex !== match.index) {
				result.push({ text: template.substr(lastIndex, match.index - lastIndex) });
			}
	
			lastIndex = formatRegex.lastIndex;
			result.push({ field: match[1] });
		}
	
		if (lastIndex !== template.length) {
			result.push({ text: template.substr(lastIndex, template.length - lastIndex) });
		}
	
		return result;
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("prop-types");

/***/ }
/******/ ]);
//# sourceMappingURL=command-sentence.js.map